/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs */

const en_cv_extract_form_enum_teaching_and_educational_sciences30 = /** @type {(inputs: Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching and Educational Sciences`)
};

const de_cv_extract_form_enum_teaching_and_educational_sciences30 = /** @type {(inputs: Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt und Erziehungswissenschaften`)
};

/**
* | output |
* | --- |
* | "Teaching and Educational Sciences" |
*
* @param {Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_teaching_and_educational_sciences30 = /** @type {((inputs?: Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Teaching_And_Educational_Sciences30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_teaching_and_educational_sciences30(inputs)
	return en_cv_extract_form_enum_teaching_and_educational_sciences30(inputs)
});
export { cv_extract_form_enum_teaching_and_educational_sciences30 as "cv_extract_form_enum_TEACHING_AND_EDUCATIONAL_SCIENCES" }